import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrendingCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTrendingCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 9V11H13.5858L12 12.5858L10 10.5858L6.33579 14.25L7.75 15.6642L10 13.4142L12 15.4142L15 12.4142V14H17V9H12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrendingCircle;
